// app/javascript/controllers/dropdown_controller.js
import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
    static targets = ["menu"]

    toggle(event) {
        event.stopPropagation()
        this.menuTarget.classList.toggle("hidden")
    }

    hide(event) {
        if (this.element.contains(event.target)) return
        this.menuTarget.classList.add("hidden")
    }
}